import React from "react";

import Image from "./Image";
import Columns from "./Columns";
import RawHtml from "./RawHtml";

const switchBlocks = {
  "core/image": Image,
  "core/columns": Columns
};

// Exposé pour le test « garde catalogue » (croisement des couches de blocs).
export const handledBlockNames = Object.keys(switchBlocks);

const Core = ({ blockName, innerHTML, ...rest }) => {
  // Validation des props
  if (!blockName || typeof blockName !== 'string') {
    return (
      <div role="alert" aria-live="polite" className="block-error">
        Bloc non défini
      </div>
    );
  }

  // Vérification si le bloc est reconnu
  if (blockName in switchBlocks) {
    const BlockComponent = switchBlocks[blockName];
    return <BlockComponent {...rest} />;
  }

  // Fallback pour les blocs non reconnus (ex. core/html). RawHtml exécute
  // réellement les éventuels <script> — ce que React / dangerouslySetInnerHTML
  // ne font jamais — et respecte le consentement cookies.
  if (innerHTML && innerHTML.trim() !== '') {
    return <RawHtml html={innerHTML} blockName={blockName} />;
  }

  // Cas où ni blockName ni innerHTML ne sont valides
  return (
    <div role="alert" aria-live="polite" className="block-error">
      Bloc {blockName} non supporté et sans contenu de fallback
    </div>
  );
};

export default Core;
